const CANON = process.env.REACT_APP_CANONICAL_URL;
// on larus.canus.io the API is same-origin, so session cookies stay first-party
const BASE = CANON && window.location.origin === CANON ? "/api" : `${process.env.REACT_APP_BACKEND_URL}/api`;

export class ApiError extends Error {
  status: number;
  data: any;
  constructor(status: number, message: string, data: any) {
    super(message);
    this.status = status;
    this.data = data;
  }
}

export function detailText(detail: any): string {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail === "object") {
    const parts = [detail.conflict, ...(detail.reasons || [])].filter(Boolean);
    if (parts.length) return parts.join(" · ");
    if (typeof detail.msg === "string") return detail.msg;
  }
  return String(detail);
}

export async function api<T = any>(path: string, opts: { method?: string; body?: any; form?: FormData } = {}): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`${BASE}${path}`, {
      method: opts.method || (opts.body || opts.form ? "POST" : "GET"),
      credentials: "include",
      headers: opts.form ? undefined : { "Content-Type": "application/json" },
      body: opts.form ? opts.form : opts.body ? JSON.stringify(opts.body) : undefined,
    });
  } catch {
    throw new ApiError(0, "You appear to be offline. Changes were not sent.", null);
  }
  const text = await res.text();
  let data: any = null;
  try { data = text ? JSON.parse(text) : null; } catch { data = text; }
  if (!res.ok) {
    if (res.status === 401 && !path.startsWith("/auth/")) window.dispatchEvent(new CustomEvent("larus:unauthorised"));
    throw new ApiError(res.status, detailText(data?.detail), data?.detail);
  }
  return data as T;
}

export const downloadUrl = (oid: string) => `${BASE}/objects/${oid}/download`;
